import { multiFilter } from "@homebound/beam";
import { useUseGlobalOptionTagsFilterLazyQuery } from "src/components/autoPopulateFilters/useGlobalOptionTagsFilter.generated";
import { GlobalOptionTagsFilter } from "src/generated/graphqlTypes";

export function useGlobalOptionTagsFilter(filter: GlobalOptionTagsFilter = {}) {
  const [load, { data }] = useUseGlobalOptionTagsFilterLazyQuery({ variables: { filter }, fetchPolicy: "cache-first" });
  return multiFilter({
    label: "Tag",
    options: { current: undefined, load, options: data?.globalOptionTags ?? [] },
    getOptionLabel: ({ name }) => name,
    getOptionValue: ({ id }) => id,
  });
}
